


































































































































































































































































































































































































































































































import { Component, Prop, Vue, Provide, Watch } from "vue-property-decorator";
import CategoryPathsViewer from "@/components/CategoryPathsViewer.vue";
import errorsUtil from "./../utils/errorMappings";
import _ from "lodash";

@Component({
  components: { CategoryPathsViewer },
})
export default class BulkProgress extends Vue {
  @Provide("$api") $api: any;
  @Provide("$_") $_: any;

  @Prop() private accountId!: string;
  @Prop() private companyId!: string;
  @Prop() private jobId!: string;

  private jobDetails: any = {};
  private questionare: any = {};

  //updated on periodic status check calls
  private jobStatus = "";
  private progress = 0;
  private progressText = "";

  private fromJobsList = false;
  private downloadTriggered = false;
  private syncToItemMaster = false;
  private loading = false;
  private errorMessageTop = "";
  private showMultiquestion = false;

  mounted() {
    this.getJobDetails();
    this.getQuestionare();
  }

  toggleMultiquestion() {
    this.showMultiquestion = !this.showMultiquestion;
  }

  private displayError(error) {
    const errorCode = error.response.data.code;
    if (_.has(errorsUtil.errorMessages, errorCode)) {
      this.$store.commit("recordError", "");
      this.errorMessageTop = errorsUtil.errorMessages[errorCode];
    }
  }

  isInternalExpertWithSupport() {
    return (
      this.$store.state.herculeRole == "ClassificationInternalExpert" &&
      this.jobStatus == "SUPPORT"
    );
  }

  async feedback() {
    try {
      if (this.jobDetails.status === "REVIEW COMPLETE") {
        this.loading = true;
        this.$store.commit("startLoading");
        const feedbackResponse = await this.$api.post(
          `item-classification-api/v1/jobs/${this.companyId}/${this.jobId}/feedback`
        );
        this.$store.commit("stopLoading");
      }
      this.$router.push({
        path: `/classification/${this.accountId}/${this.companyId}/${this.jobId}/feedback`,
      });
    } catch (error) {
      this.displayError(error);
      this.$store.commit("stopLoading");
      this.loading = false;
    }
  }

  getJobDetails() {
    this.$store.commit("startLoading");
    this.loading = true;
    this.$api
      .get(`item-classification-api/v1/jobs/${this.companyId}/${this.jobId}`)
      .then((response) => {
        this.jobDetails = response.data;
        this.jobStatus = this.jobDetails.status;
        if (
          this.jobStatus === "PROCESSING" &&
          this.jobDetails.totalRecords > 0
        ) {
          this.progress =
            (this.jobDetails.processedRecords / this.jobDetails.totalRecords) *
            100;
          this.progressText = `${this.jobDetails.processedRecords} out of ${this.jobDetails.totalRecords} items processed`;
          setTimeout(this.checkStatus, 2500);
        }
        this.$store.commit("stopLoading");
        this.loading = false;
      })
      .catch((error) => {
        this.$store.commit("stopLoading");
        this.loading = false;
        this.displayError(error);
      });
  }

  async getQuestionare() {
    try {
      const response = await this.$api.get(
        `item-classification-api/v1/jobs/${this.companyId}/${this.jobId}/questionnaire`
      );
      this.questionare = response.data;
    } catch (error) {
      this.$store.commit("stopLoading");
      this.loading = false;
      this.displayError(error);
    }
  }

  private areJobQuestionsPresent(questions: any[]) {
    return (
      questions &&
      questions.filter((question) => this.showQuestion(question)).length > 0
    );
  }

  private showQuestion(question: any) {
    const rules: any[] = question.rules;
    const herculeRole = this.$store.state.herculeRole;
    const featureLevel = this.$store.getters.featureLevel(
      "item-classification"
    );
    const basedOnRules = !rules
      ? true
      : rules.some(
          (rule) =>
            rule.featureLevel === featureLevel &&
            rule.roles.indexOf(herculeRole) >= 0
        );
    const basedOnSupport = !question.support
      ? true
      : question.support.toString() == this.jobDetails.metadata.support;
    return basedOnRules && basedOnSupport;
  }

  private answerFor(question: any) {
    switch (question.questionType) {
      case "singleArea":
        return (question?.answer as string).trim() === ""
          ? "None"
          : (question?.answer as string).trim();
      case "single":
        return (question?.answer as string).trim() === ""
          ? "None"
          : (question?.answer as string).trim();
      case "multiSelect":
        return (question?.answer as Array<string>).join(", ");
      case "date":
        return (question?.answer as string).trim() === ""
          ? "None"
          : (question?.answer as string).trim();
      case "singleSelect":
        return (question?.answer as string).trim();
    }
  }

  checkStatus() {
    this.$api
      .get(
        `item-classification-api/v1/jobs/${this.companyId}/${this.jobId}/status`
      )
      .then((response) => {
        this.jobStatus = response.data.status;
        const totalRecords = response.data.totalRecords;
        const processedRecords = response.data.processedRecords;
        this.$store.commit("stopLoading");
        if (this.jobStatus === "PROCESSING" && totalRecords > 0) {
          this.progress = (processedRecords / totalRecords) * 100;
          this.progressText = `${processedRecords} out of ${totalRecords} items processed`;
          setTimeout(this.checkStatus, 2500);
        }
      })
      .catch((error) => {
        this.$store.commit("stopLoading");
        this.loading = false;
        this.displayError(error);
      });
  }

  async startJob() {
    this.$store.commit("startLoading");
    this.$api
      .post(
        `item-classification-api/v1/jobs/${this.companyId}/${this.jobId}/start`,
        null,
        { params: { syncToItemMaster: this.syncToItemMaster } }
      )
      .then((response) => {
        this.$router.push({
          path: `/classification/${this.accountId}/${this.companyId}/jobs`,
        });
        this.$store.commit("stopLoading");
        this.$store.commit("recordToast", "Job started successfully");
      })
      .catch((error) => {
        this.$store.commit("stopLoading");
        this.displayError(error);
      });
  }

  async downloadOutput(downloadType: string) {
    try {
      this.$store.commit("startLoading");
      const downloadResponse = await this.$api.get(
        `item-classification-api/v1/jobs/${this.companyId}/${this.jobId}/${downloadType}`,
        {
          params: {},
          responseType: "arraybuffer",
          headers: {
            Accept: "application/octet-stream",
          },
        }
      );

      const url = window.URL.createObjectURL(new Blob([downloadResponse.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "output.csv");
      document.body.appendChild(link);
      link.click();
      this.$store.commit("stopLoading");
    } catch (e) {
      this.$store.commit("stopLoading");
      this.loading = false;
      this.displayError(e);
    }
  }

  private fieldMappingKeys() {
    return this.jobDetails.fieldMapping
      ? Object.keys(this.jobDetails.fieldMapping)
      : [];
  }

  private formatFieldMapping(mapping) {
    if (mapping.fields.length == 1) {
      return mapping.fields[0];
    } else {
      return mapping.joinType == "concat"
        ? mapping.fields.join(mapping.delimiter) + " (concatenated)"
        : mapping.fields.join(" or ") + " (coalesced)";
    }
  }

  private changeStep(step) {
    (this.$parent as any).gotoStep(step);
  }

  private previous() {
    (this.$parent as any).previousStep();
  }

  private cancel() {
    this.$router.push({
      path: `/classification/${this.accountId}/${this.companyId}/jobs`,
    });
  }
}
